import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { GrowlService } from '../../services/ui-feedback/growl.service';
import { ButtonDirective } from '../button/button.directive';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-growl-host',
  standalone: true,
  imports: [RouterLink, ButtonDirective, IconComponent],
  templateUrl: './growl-host.component.html',
  styleUrl: './growl-host.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GrowlHostComponent {
  // Private variables

  // Public properties

  // Constructors

  constructor(public readonly growls: GrowlService) {}

  // Public methods

  // Private methods
}
